import React, { useState, useEffect, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Box, {
    Item
  } from 'devextreme-react/box';
import { Button } from 'devextreme-react/button';
import DataGrid,{ Column, Lookup, Editing }from 'devextreme-react/data-grid';
import uri from '../../utils/uri';
import http from '../../utils/http';
import SelectBox from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import BlockHeader from '../shared/BlockHeader';
import { initialStateExtendCiclo, initialStateExtendPrisma, initialStateExtendSubj } from '../../data/graduacionesInit';
import { primsaImage } from '../../data/logo';
import { useSelector, useDispatch } from 'react-redux';
import { updateGraduacion } from '../../store/graduacion/graduacionReducer';
import { esferas, cilindros, ejes, adiciones,avscs, prismasList, ejesPrima, bases, dlps } from '../../utils/custom';
import useAuthorization from '../../hooks/useAuthorization';
import { dataAccess, resources } from '../../data/app';
import notify from 'devextreme/ui/notify';

const Nuevo = (props) => {

    const dispatch = useDispatch();

    const { auth } = useAuthorization([resources.editarGraduaciones, dataAccess.access ]);

    const [refraccSubjetivas, setRefraccSubjetivas] = useState([{...initialStateExtendSubj, eye:'OD'},{...initialStateExtendSubj, eye:'OI'}]);
    const [refraccCicloplejicas, setRefraccCicloplejicas] = useState([{...initialStateExtendCiclo, eye:'OD'},{...initialStateExtendCiclo, eye:'OI'}]);
    const [prismas, setPrismas] = useState([{...initialStateExtendPrisma, eye:'OD'},{...initialStateExtendPrisma, eye:'OI'}]);

    const [data, setData] = useState({id: 0, dp: '', observation : '', nextDateRecord: null});
    const [saving, setSaving] = useState(false);

    const {  clientId,id, open } = useSelector(store => store.graduacion);

    const refGridSubjetiva = useRef()
    const refGridClicloplejica = useRef()
    const refPrisma = useRef()

    const statusEditorRender = (cell) => {

        let _onValueChanged = onValueChanged.bind(this, cell);
        return <SelectBox
        searchEnabled={true}
          defaultValue={cell.value == '' ? '0.00' : cell.value}
          {...cell.column.lookup}
          itemRender={itemRender}
          onValueChanged={_onValueChanged}
        />;

      }

    const itemRender = (data) => {
       
        return  <div>            
                    <span className={data.value < 0 ? "negative" : ""}>{data.text}</span>
                </div>;
    }

    const statusEditorRenderImage = (cell) => {

        let _onValueChanged = onValueChangedImage.bind(this, cell);
        return <SelectBox
        searchEnabled={true}
          defaultValue={cell.value}
          {...cell.column.lookup}
          itemRender={itemRenderImage}
          onValueChanged={_onValueChanged}
        />;

      }

    const itemRenderImage = (data) => {
        let imageSource = primsaImage;
        return  <div>       
                    {imageSource}   
                    <span>{data.text}</span>
                </div>;
    }

    const onValueChanged = (cell, e) => {
        cell.setValue(e.value);
    }

    const onValueChangedImage = (cell, e) => {
        cell.setValue(e.value);
    }

    const onCellPrepared = e => {
        
        if (e.rowType == 'data') {

            if(e.column.dataField == "sphere")
                if(e.data.sphere < 0)
                    e.cellElement.classList.add('negative');

            if(e.column.dataField == "cylinder")
                if(e.data.cylinder < 0)
                    e.cellElement.classList.add('negative');

        }

    }
    
   
    const onValueChangedDataObs = (e) => {
        setData({...data, observation: e.value})
    }

    const onValueChangedDataDate = (e) => {
        setData({...data, nextDateRecord: e.value})
    }

    const guardarGrabacion = (params) => {

        let _uri = uri.records(clientId);

        refGridSubjetiva.current.instance.saveEditData();
        refGridClicloplejica.current.instance.saveEditData();
        refPrisma.current.instance.saveEditData();

        let record = {
            ...data,
            id: data.id || 0,
            clientId,
            prisms : [...prismas],
            refractions : [...refraccSubjetivas],
            refractionsCycloplegics: [...refraccCicloplejicas]
        }        

        setSaving(true);
        http(_uri.insert).asPost(record).then(x => {     

            setSaving(false);     
            const { reload } = props;
            let result = reload?.();
            onHiding();

        }).catch(err => {

            notify(err,"error");
            setSaving(false);    
             
        });

    }

    const onHiding = (e) => {

        setRefraccSubjetivas([{...initialStateExtendSubj, eye:'OD'},{...initialStateExtendSubj, eye:'OI'}]);
        setRefraccCicloplejicas([{...initialStateExtendCiclo, eye:'OD'},{...initialStateExtendCiclo, eye:'OI'}]);
        setPrismas([{...initialStateExtendPrisma, eye:'OD'},{...initialStateExtendPrisma, eye:'OI'}]);

        dispatch(updateGraduacion({ open: false, id :0, clientId : 0}))
    }

    useEffect(() => {   
        if(id > 0){

            http(uri.records().getById(id)).asGet().then(resp => {
                
                setData(resp);
                setPrismas(resp.prisms);
                setRefraccSubjetivas(resp.refractions);
                setRefraccCicloplejicas(resp.refractionsCycloplegics);
                
            });
        }else{
            setData({ id: 0, dp: '', observation : '', nextDateRecord: null} )
        }

    }, [id]);

    const canEdit = auth.toEdit || id == 0;

    return (
        <div>
             <Popup
                width={880}
                height={700}
                title={`Nueva graduación`}
                visible={open}
                onHiding={onHiding}
            >
                
                <BlockHeader title='Refraccion subjetiva'></BlockHeader>
                <DataGrid         
                    ref={refGridSubjetiva}           
                    dataSource={refraccSubjetivas}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}                   
                    onCellPrepared={onCellPrepared}                    
                >
                     <Editing
                        mode="cell"
                        allowUpdating={canEdit}
                    ></Editing>
                    <Column dataField="eye" width={60} caption='Rx' allowSorting={false} allowEditing={false} />
                    <Column dataField="sphere" caption="Esfera" width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center'>
                        <Lookup dataSource={esferas} valueExpr="value" displayExpr="text"  />
                    </Column>
                    <Column dataField="cylinder" caption="Cilindro" width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center' >
                        <Lookup dataSource={cilindros} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField="axis" caption="Eje" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={ejes} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField='addition' caption="Adición" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={adiciones} valueExpr="value" displayExpr="text" />
                    </Column>   
                    <Column dataField="avsc" width={100} allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={avscs} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField="avcc" width={100} allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={avscs} valueExpr="value" displayExpr="text" />
                    </Column>               
                    {/* <Column dataField="dpl" caption="DPL/DPC" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={dlps} valueExpr="value" displayExpr="text" />
                    </Column>                                  
                    <Column dataField="dpc" allowFiltering={false} allowSorting={false} alignment='center' visible={false}>
                        <Lookup dataSource={dlps} valueExpr="value" displayExpr="text" />
                    </Column>                       */}
                </DataGrid>
                <br/>
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={1}>
                        <div style={{display : 'flex'}}>
                            <span className="pt-7">DPL/DPC:</span>
                            <SelectBox items={dlps} 
                                onValueChanged={e => {
                                    setData({...data, dp: e.value});                                     
                                } }
                                displayExpr="text"
                                valueExpr="value"
                            />
                        </div>
                    </Item>
                    <Item ratio={4}>                       
                    </Item>
                </Box>
                <BlockHeader title='Refraccion Cicloplejicas'></BlockHeader>                
                <DataGrid                
                    ref={refGridClicloplejica}    
                    dataSource={refraccCicloplejicas}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}                   
                    onCellPrepared={onCellPrepared}
                >
                     <Editing
                        mode="cell"
                        allowUpdating={canEdit}              
                    ></Editing>
                    <Column dataField="eye" width={60} caption='Rx' allowSorting={false} allowEditing={false} />
                    <Column dataField="sphere" caption="Esfera" width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center'>
                        <Lookup dataSource={esferas} valueExpr="value" displayExpr="text"  />
                    </Column>
                    <Column dataField="cylinder" caption="Cilindro" width={100} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center' >
                        <Lookup dataSource={cilindros} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField="axis" caption="Eje" width={100} allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={ejes} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField='av' width={100} caption="AV" allowFiltering={false} allowSorting={false} alignment='center'>
                        <Lookup dataSource={avscs} valueExpr="value" displayExpr="text" />
                    </Column>  
                </DataGrid>
                <BlockHeader title='Indicaciones Prisma'></BlockHeader>
                <DataGrid        
                    ref={refPrisma}            
                    dataSource={prismas}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}                   
                    onCellPrepared={onCellPrepared}
                >
                     <Editing
                        mode="cell"
                        allowUpdating={canEdit}            
                    ></Editing>
                    <Column dataField="eye" width={60} caption='Rx' allowSorting={false} allowEditing={false} />
                    <Column dataField="prismId" caption="Prisma" width={80} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRenderImage} alignment='center'>
                        <Lookup dataSource={prismasList} valueExpr="value" displayExpr="text"  />
                        
                    </Column>
                    <Column dataField="base" width={120} allowFiltering={false} allowSorting={false} editCellRender={statusEditorRender} alignment='center' >
                        <Lookup dataSource={bases} valueExpr="value" displayExpr="text" />
                    </Column>               
                    <Column dataField="axis" caption="Eje" width={120} allowFiltering={false} allowSorting={false}  alignment='center'>
                        <Lookup dataSource={ejesPrima} valueExpr="value" displayExpr="text" />
                    </Column>      
                </DataGrid>
                <br/>              
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={3}>
                        <div className="option">
                            <span>Observacion:</span>
                            <TextBox defaultValue={data.observation} value={data.observation} placeholder="Observacion" onValueChanged={onValueChangedDataObs} disabled={!canEdit}></TextBox>
                        </div>
                    </Item>
                    <Item ratio={1}></Item>
                    <Item ratio={1}>
                        <div className="option">
                            <span>Próx. graduación:</span>
                            <DateBox openOnFieldClick={true} defaultValue={data.nextDateRecord} value={data.nextDateRecord} disabled={!canEdit} displayFormat='dd/MM/yyyy' onValueChanged={onValueChangedDataDate}></DateBox>
                        </div>                        
                    </Item>                   
                </Box>
                <br/>
                <Box direction="row" width="100%" height={50}>
                    <Item ratio={4}></Item>
                    <Item ratio={1}>
                        <Button  className="btn-header-menu" icon="save" 
                        text={`${saving?'Guardando...':'Guardar'}`}
                        disabled={saving}
                        type='default' 
                        onClick={guardarGrabacion} visible={canEdit} />
                    </Item>
                </Box>
            </Popup>
        </div>
    );
}

export default Nuevo;
